import React from 'react';

const Type = (type?: 'website' | 'product' | 'product.group' | 'article') => (
  <meta name="og:type" property="og:type" content={type || 'website'} />
);

export default Type;
